import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import ItemService from '~/components/ItemService';
import config from '~/config';
import classes from './CategoryHome.module.scss';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import { getNumberWithCommas } from '~/utils';

const cx = classNames.bind(classes);

const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '70px',
    slidesToShow: 1,
    speed: 500,
};

export default function CategoryHome({ data }) {
    const navigate = useNavigate();

    return (
        <div className={cx('wrapper')}>
            <div className={cx('wrapper-inner')}>
                <div className={cx('heading')}>
                    <h3>Service</h3>
                </div>
                <Row className={cx('container_service')}>
                    {data &&
                        data.length > 0 &&
                        data?.map((item, index) => {
                            return (
                                <Col xs={24} sm={12} lg={6} key={index}>
                                    <Row>
                                        <ItemService data={item} />
                                    </Row>
                                </Col>
                            );
                        })}
                </Row>
                <div className={cx('service_slide')}>
                    <Slider {...settings}>
                        {data &&
                            data.length > 0 &&
                            data?.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <div
                                            className={cx('card_service')}
                                            onClick={() => navigate(`/dich-vu-chi-tiet/${item?.id}`)}
                                        >
                                            <div className={cx('card_image')}>
                                                <img src={item?.image || IMAGES.ImagePlaceholder} alt="img-service" />
                                                {item.discount > 0 && (
                                                    <div className={cx('card_discount')}>
                                                        <span>
                                                            -{Math.round((item?.discount * 100) / item?.price)}%
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            <p className={cx('card_title')}>{item?.title}</p>
                                            <Row align="middle" justify="space-between" className={cx('card_info')}>
                                                <Row align="bottom" className={cx('card_price')}>
                                                    <span>
                                                        {getNumberWithCommas(item?.price - item?.discount)}&nbsp;
                                                    </span>
                                                    <span>{item?.unit_id ? `d/${item?.unit?.value}` : 'd'}</span>
                                                </Row>
                                                <Row align="middle" className={cx('card_time')}>
                                                    <img src={SVGS.IconClock} alt="icon-clock" />
                                                    <span>{item?.execution_time} minutes</span>
                                                </Row>
                                            </Row>
                                        </div>
                                    </div>
                                );
                            })}
                    </Slider>
                </div>
                <div className={cx('textCenter')}>
                    <button className={cx('loadMore')} onClick={() => navigate(config.routes.spa)}>
                        see more
                    </button>
                </div>
            </div>
        </div>
    );
}
